module.exports = __webpack_public_path__ + "static/media/masthead-narrogin-observer.c4e5dfaf.svg";